import React from 'react';
import { List } from 'semantic-ui-react'

import TitDer from '../../../components/funcionales/titder';

//Tipos de recursos
const DetalleNivel1 = ({elemento, handleClickidLista}) => {
  return(
    <tr className=''  onClick={(ev)=>handleClickidLista(ev, elemento)}>
      <td className=''>{elemento.descrTipoRec}</td>
      <td className=''>{elemento.areaAprovech}</td>
    </tr>
  )
};

const Lista = ({list, handleClickidLista}) => {
  const nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento} 
    handleClickidLista={handleClickidLista} key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

const ConfTire2 = ({autorizacUA, styles, handleClick, list, handleClickidLista}) => {
  const a253001 = autorizacUA.findIndex( autorizac => autorizac === "253001" );

  return (
    <div>
      <List selection>
        <TitDer list={list} textBoton1="Tipos de recurso" btnNuevo={a253001!==-1?"SI":"NO"} styles={styles} handleClick={handleClick} />
        <div>
          <table className='ui blue inverted celled selectable table' style={styles.styTableSup}>
            <thead className=''>
              <tr className=''>
                <th className='' style={{width: '50%'}}>Descripción</th>
                <th className='' style={{width: '50%'}}>Area de aprovechamiento</th>
              </tr>
            </thead>
            <Lista list={list} handleClickidLista={handleClickidLista}/>
          </table>
          <p></p>
        </div>
      </List>
    </div>
  )
};

export default ConfTire2
